import { render, staticRenderFns } from "./systemControl.vue?vue&type=template&id=1481fa50&scoped=true&"
import script from "./systemControl.vue?vue&type=script&lang=ts&"
export * from "./systemControl.vue?vue&type=script&lang=ts&"
import style1 from "./systemControl.vue?vue&type=style&index=1&id=1481fa50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481fa50",
  null
  
)

export default component.exports